import React from 'react';
import { useInView } from 'react-intersection-observer';

function ScrollEffectWrapper({ children, delay = 0, animationType = 'default', stagger = 0 }) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const getAnimationClass = () => {
    switch (animationType) {
      case 'slide-up':
        return 'scroll-reveal-slide-up';
      case 'slide-left':
        return 'scroll-reveal-slide-left';
      case 'slide-right':
        return 'scroll-reveal-slide-right';
      case 'fade-scale':
        return 'scroll-reveal-fade-scale';
      case 'pop':
        return 'scroll-reveal-pop';
      case 'title':
        return 'scroll-reveal-title';
      default:
        return 'scroll-reveal';
    }
  };

  const getStaggerClass = () => {
    if (stagger > 0 && stagger <= 6) {
      return `scroll-reveal-stagger-${stagger}`;
    }
    return '';
  };

  return (
    <div
      ref={ref}
      className={`${getAnimationClass()} ${getStaggerClass()} ${inView ? 'visible' : ''}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

export default ScrollEffectWrapper;
